import { RequireAuth } from "@/components/auth/RequireAuth";
import CaixaApp from "@caixa/App";
import "@caixa/index.css";
import "@caixa/caixa-modal.css";

/** App do caixa — montado no bundle principal após autenticação. */
function CaixaAppFrame() {
  return (
    <div className="w-full bg-[#141414] max-lg:min-h-[100dvh] max-lg:overflow-x-hidden max-lg:overflow-y-auto lg:h-[100dvh] lg:overflow-hidden">
      <CaixaApp />
    </div>
  );
}

/**
 * Porta de autenticação do caixa em `/caixa`:
 * sem sessão → login; com sessão → app do caixa (mesmo SPA do sistema).
 */
export default function CaixaAuthPage() {
  return (
    <RequireAuth
      redirectTo="/caixa"
      loginTitle="Faça login para acessar o caixa"
    >
      <CaixaAppFrame />
    </RequireAuth>
  );
}
